// Global configuration variables
export const CONFIG = {
  BUSINESS_NAME: "BPA Trade Pages",
  BRAND_OWNER: "BPA Solutions",
  BRAND_PHONE: "0425 228 778",
  LOGO_URL: "TOBEUPDATED",
  BUSINESS_URL: "TOBEUPDATED",
  PRIMARY_SERVICE: "Premium Trade Landing Pages",
  PRIMARY_LOCATION: "Australia",
  PACKAGE_PRICE_ONETIME: 897,
  ONGOING_PRICE_MONTHLY: 20,
  ONGOING_STARTS_AFTER_MONTHS_FREE: 3,
  EMAIL_ADDRESSES_INCLUDED: 2,
  PAYMENT_LINK_URL: "TOBEUPDATED",
  FEEDBACK_RECORDING_URL: "TOBEUPDATED",
  SUPPORT_EMAIL: "support@bpasolutions.au",
  SERVICE_LOCATIONS_EXTENDED: [
    "Penrith NSW", "Logan QLD", "Dandenong VIC", "Mandurah WA",
    "Toowoomba QLD", "Northern Beaches NSW", "Parramatta NSW", "Geelong VIC"
  ],
  // Google Apps Script CMS URL (optional - site works without it)
  BPAS_CMS_URL: import.meta.env.VITE_BPAS_CMS_URL || "",
  // Form submission URL (can be same as CMS URL)
  FORM_SUBMIT_URL: import.meta.env.VITE_FORM_SUBMIT_URL || "",
  // Feature flags
  PREVIEW_MODE: false,
  ENABLE_GALLERY: false,
  ENABLE_CLIENT_STORIES: false
};